// Updated Component Class
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { IPropertiesState } from './store/properties.state';
import { Observable } from 'rxjs';
import { setPropertiesAction } from './store/properties.actions';
import { getPropertiesSelectors } from './store/properties.selectors';
import {
  IIndividualsProperties,
  IProperties,
} from 'src/app/modules/interfaces/properties.interface';
import { PropertiesService } from 'src/app/services/properties.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss'],
})
export class PropertiesComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();
  formsId: number;
  propertiesData: IProperties = {
    id: 0,
    has_property: null,
    wants_property_study: null,
    individuals_properties: [],
  };

  individualsPropertiesLocal: IIndividualsProperties[];

  isLoading = true;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataState$: Observable<IPropertiesState>;
  dataState: IPropertiesState = {
    check: true,
    properties: undefined,
    interest: false,
    listProperties: [],
  };

  listLocal: Array<any> = [];

  constructor(
    private store: Store,
    private propertiesService: PropertiesService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  async ngOnInit() {
    this.loadPropertiesData();
    await this.getState();

    this.listLocal = [...this.dataState.listProperties];

    if (this.listLocal.length === 0) {
      await this.addList();
    }
  }

  loadPropertiesData(): void {
    this.isLoading = true
    this.propertiesService
      .getPropertiesData(this.formsId)
      .subscribe((response) => {
        if (response) {
          (this.propertiesData = {
            id: response.id,
            has_property: response.has_property,
            wants_property_study: response.wants_property_study,
            individuals_properties: response.individuals_properties,
          }),
            (this.individualsPropertiesLocal = response.individuals_properties);
          this.saveState();
        }
      });
  }

  updateIndividualList(data, index): void {
    if (this.isValidIndex(index)) {
      const updatedProperties = [...this.propertiesData.individuals_properties];
      updatedProperties[index] = { ...data };

      this.propertiesData.individuals_properties = updatedProperties;
    }
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const updateData: IProperties = {
      ...this.propertiesData,
      wants_property_study: this.propertiesData.wants_property_study ? 1 : 0,
    };
    this.propertiesService
      .updatePropertiesData(this.formsId, this.propertiesData.id, updateData)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.saveButtonText = 'Salvo';
          this.saveButtonClass = 'btn-primary';
          this.saveState();
          this.formSaved.emit();
        },
        error: (err) => {
          this.isSaving = false;
          this.saveButtonText = 'Erro ao salvar';
          this.saveButtonClass = 'btn-danger';
          console.error('Erro ao atualizar os dados de Imovél', err);
        },
      });
  }

  saveState(): void {
    this.dataState = {
      ...this.dataState,
      check: this.individualsPropertiesLocal.length > 0,
      properties: this.propertiesData.has_property === 1,
      interest: this.propertiesData.wants_property_study === 1,
      listProperties: this.individualsPropertiesLocal.map((property) => ({
        check: true,
        estimatedValue: Number(property.property_value),
        propertyFinanced: property.has_financed === 1,
        notes: property.notes || '',
      })),
    };
  
    this.setState(this.dataState);
  }
  

  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }
  

  isValidIndex(index: number): boolean {
    return index >= 0 && index < this.individualsPropertiesLocal.length;
  }

  addList(): void {
    if (!Array.isArray(this.individualsPropertiesLocal)) {
      this.individualsPropertiesLocal = [];
    }

    const newProperty: IIndividualsProperties = {
      properties_id: this.propertiesData.id,
      property_value: 0,
      has_financed: 0,
      notes: '',
    };

    this.individualsPropertiesLocal = [
      ...this.propertiesData.individuals_properties,
      newProperty,
    ];
    this.propertiesData.individuals_properties = [
      ...this.propertiesData.individuals_properties,
      newProperty,
    ];
  }

  setState(data: IPropertiesState) {
    this.store.dispatch(setPropertiesAction(data));
    this.isLoading = false
  }

  getState() {
    this.dataState$ = this.store.select(getPropertiesSelectors);

    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = !!this.dataState.properties;
    this.setState(this.dataState);
  }

  updateList(data, index): void {
    if (this.isValidIndex(index)) {
      const updatedProperties = [...this.dataState.listProperties];
      updatedProperties[index] = { ...data };

      this.dataState.listProperties = updatedProperties;
      this.setState(this.dataState);
    }
  }

  deleteList(index: number): void {
    if (this.isValidIndex(index)) {
    
      this.individualsPropertiesLocal.splice(index, 1);
      this.propertiesData.individuals_properties.splice(index, 1);
    
      this.dataState.listProperties = this.individualsPropertiesLocal.map((property) => ({
        check: true,
        estimatedValue: Number(property.property_value),
        propertyFinanced: property.has_financed === 1,
        notes: property.notes || '',
      }));
  
      this.setState(this.dataState);
    }
  }

  // updateAmount(event): void {
  //   this.dataState.amount = event;
  //   this.setValuesForm();
  // }
}
